module.exports = __webpack_public_path__ + "img/service-screen-character.f68489ef.png";